import PubSub from 'pubsub-js';
import { gsap } from 'gsap';

const header = {
  $header: document.getElementById('main_header'),
  init() {
    console.log('Header init');

    this.setUpListeners();
  },

  setUpListeners() {
    const $mobileMenu = document.getElementById('mobile_menu');

    PubSub.subscribe(
      'header.updateMenuItems',
      this.updateMenuItems.bind(this)
    );

    PubSub.subscribe(
      'header.toggleColor',
      this.toggleColor.bind(this)
    );

    window.addEventListener('scroll', this.scrollHandler.bind(this));

    this.$header
      .querySelector('.menu_toggler')
      .addEventListener('click', () => {
        $mobileMenu.classList.add('active');
      });

    $mobileMenu
      .addEventListener('click', ev => {
        if (ev.target.closest('.close')
        || ev.target.closest('.menu-item')) {
          $mobileMenu.classList.remove('active');
        }
      });
  },

  updateMenuItems(ev, $newHeader) {
    const $currMenuItems = this.$header.querySelectorAll('.menu-item');

    $newHeader
      .querySelectorAll('.menu-item')
      .forEach(($el, id) => {
        $currMenuItems[id]
          .setAttribute(
            'class',
            $el.getAttribute('class')
          );
      });
  },

  toggleColor() {
    const $firstModule = document.querySelector('main > section');
    const shouldBeWhite = $firstModule.classList.contains('generic_header')
      && $firstModule.classList.contains('with_bg')
      && $firstModule.classList.contains('white_text');

    if (shouldBeWhite) {
      this.$header.classList.add('white_header');
    } else {
      this.$header.classList.remove('white_header');
    }
  },

  prevTop: 0,
  hideDelay: 30,
  currHideDelay: 0,
  scrollHandler() {
    const currTop = document.documentElement.scrollTop;
    const isCompact = this.$header.classList.contains('compact');
    const isVisible = this.$header.classList.contains('visible');
    const isMobile = this.wWidth < 768;
    // 0.6 because start pos of header is 0.6rem
    const headerTop = 0;
    const mobileHeaderTop = 0;

    if (((currTop > headerTop && !isMobile)
      || (currTop > mobileHeaderTop && isMobile)
    ) && !isCompact) {
      this.$header.classList.add('compact');
    } else if (((currTop <= headerTop && !isMobile)
      || (currTop <= mobileHeaderTop && isMobile)
    ) && isCompact) {
      this.$header.classList.remove('compact');
    }

    // hide on scroll down
    if (currTop < this.prevTop && !isVisible && isCompact) {
      this.$header.classList.add('visible');
    } else if (currTop > this.prevTop && isVisible && isCompact) {
      if (this.currHideDelay >= this.hideDelay) {
        this.$header.classList.remove('visible');
        this.currHideDelay = 0;
      } else {
        this.currHideDelay++;
      }
    }

    this.prevTop = currTop;
  }
};


export default header;
